import { Consumer, Subscription } from "@rails/actioncable"
import { useQueryClient } from "@tanstack/react-query"
import { AppContext } from "Shared/AppContext"
import { reportErrorToSentry } from "Utilities/error"
import { useContext, useEffect, useRef } from "react"
import { useUsabilityhubContext } from "~/api/generated/usabilityhub-context"

type PanelistMessage = {
  action: "moderated_study_chat_message.created" | "assignment.created"
}

export const usePanelistChannel = () => {
  const { consumer } = useContext(AppContext)
  const channel = useRef<Subscription<Consumer>>()
  const queryClient = useQueryClient()
  const { queryKeyFn } = useUsabilityhubContext()

  const unreadChatsQueryKey = queryKeyFn({
    path: "/api/moderated_study_chat_messages/unread_chats",
    operationId: "listUnreadModeratedStudyChats",
    variables: {},
  })

  const assignmentsQueryKey = queryKeyFn({
    path: "/api/order_assignments",
    operationId: "listUsercrowdOrderAssignments",
    variables: {},
  })

  useEffect(() => {
    channel.current = consumer?.subscriptions.create(
      {
        channel: "PanelistChannel",
      },
      {
        received: (message: PanelistMessage) => {
          switch (message.action) {
            case "moderated_study_chat_message.created":
              return queryClient.invalidateQueries(unreadChatsQueryKey)
            case "assignment.created":
              return queryClient.invalidateQueries(assignmentsQueryKey)
            default:
              reportErrorToSentry(
                new Error("PanelistMessage received unexpected message"),
                { extra: { message: message } }
              )
          }
        },
      }
    )
    return () => {
      channel.current?.unsubscribe()
    }
  }, [consumer, queryClient])
}
